import { gql } from "@apollo/client";

export default gql`
  query PodcastPageConfig {
    podcastPage {
      headerText
      headerTextColor
      backgroundColor
      description
      descriptionColor
      podcastSrc
      podcastHeight

      twitter
      facebook
      instagram
      youtube
      apple
      spotify
      googleplay
      soundcloud
      deezer
      iheartradio
      overcast
      stitcher
      pandora
      amazonmusic
    }
  }
`;
